import navConfig from '../layouts/main/navbar/NavConfig';
import { useMemo } from 'react';
import useConversations from './useConversations';
import useAuth from './useAuth';
import useClientMessagingVisibility from './useClientMessagingVisibility';

const useNavConfig = () => {
    const context = useAuth();
    const { isClient } = context;

    const { conversations } = useConversations();

    const { isMessagingEnabled } = useClientMessagingVisibility({ options: { skip: !isClient } });

    const unreadConversationCount = useMemo(
        () => conversations.filter((conversation) => conversation.unreadCount > 0).length,
        [conversations]
    );

    if (!context) throw new Error('Auth context must be use inside AuthProvider');

    return {
        navConfig: navConfig(context, {
            messaging: {
                unreadConversationCount,
                isEnabled: isMessagingEnabled,
            },
        }),
    };
};

export default useNavConfig;
